export default __webpack_public_path__ + "static/media/65.34cb0c23.png";